// Checkbox
export default (h, field, errorMessages, value, onInput, onBlur, onFocus, self) => {
  console.log('Checkbox Field')

  return (
    <v-checkbox
      label={field.attributes.label}
      inputValue={value}
      onChange={onInput}
      class={field.attributes.class}
    ></v-checkbox>
  )
}
